var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.content.type === 1)?_c('div',{staticClass:"message-form"},[_c('FormBranch',{attrs:{"title":_vm.content.header,"list":_vm.content.items},on:{"input-click":_vm.handleContentListItemClick}})],1):_c('div',{staticClass:"message-form"},[_c('FormInput',{attrs:{"title":_vm.content.header},on:{"input-submit":_vm.handleFormSaveInputSubmit}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }